import { render, staticRenderFns } from "./ModalWebServices.vue?vue&type=template&id=d4280bd8&scoped=true"
import script from "./ModalWebServices.vue?vue&type=script&lang=js"
export * from "./ModalWebServices.vue?vue&type=script&lang=js"
import style0 from "./ModalWebServices.vue?vue&type=style&index=0&id=d4280bd8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4280bd8",
  null
  
)

export default component.exports